import { Widget } from "blue-widgets";

class iFrameHelper extends Widget {
  constructor(el) {
    super(el);
    this.init();
  }

  init() {
    this.iFrame = this.el.querySelector("iframe");
    if (!this.iFrame) return;

    this.width = this.iFrame.getAttribute("width");
    this.height = this.iFrame.getAttribute("height");
    if (!this.width || !this.height) return;

    this.iFrame.style.aspectRatio = `${this.width} / ${this.height}`;
    this.iFrame.style.maxWidth = "100%";
    this.iFrame.style.height = "100%";
  }
}

export default iFrameHelper;
